export default "__VITE_ASSET__ELi4Z6RA__";